import React, { Component } from 'react'
import DotLoader from '../../../Loader/DotLoader.component'
import { fetchCrifReportHtmlNew, getLoanApprovalScorngById, UpdateLoanApprovalScorngById } from '../../../../containers/Admin/CreditModule/CreditNewNew/ActionCreator'
import { APIS } from '../../../../../utils/api-factory'
import { TENANT_HEADER } from '../../../../../utils/apiHeaders'
import SavePopup from '../../../Popup/Popup.component'
import SignzyData from './Signzy/SignzyData'
import SignzyUpload from './Signzy/SignzyUpload'


export default class AnalysisPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'crif', // 'crif' or 'internalScoring'
            userDetails: null,
            crifHtml: '',
            concludeData: null,
            loadingUser: false,
            loadingCrif: false,
            loadingScoring: false,
            isEditing: false,
            editScore: 0,
            editDecision: 'APPROVED',
            savingScoring: false,
            showPopup: false,
            popupStatus: ''
        };
    }

    componentDidMount() {

        this.fetchCrifData(false);
        this.fetchScoringData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.userId !== this.props.userId) {

            this.fetchCrifData(false);
            this.fetchScoringData();
        }
    }

    fetchCrifData = (regenerate) => {
        const { userId, admin } = this.props;
        if (!userId) return;

        const empId = admin?.emailId || 'superuser';
        const regenerateValue = regenerate ? 1 : 0;

        this.setState({ loadingCrif: true });

        fetchCrifReportHtmlNew(userId, regenerateValue, empId, callback => {
            if (callback) {
                this.setState({ crifHtml: callback, loadingCrif: false });
            } else {
                console.error("Error fetching CRIF data");
                this.setState({ loadingCrif: false });
            }
        });
    };

    fetchScoringData = () => {
        const { userId } = this.props;
        if (!userId) return;

        this.setState({ loadingScoring: true });
        getLoanApprovalScorngById(userId, callback => {
            this.setState({ concludeData: callback || null, loadingScoring: false });
        });
    };

    handleSaveScoring = () => {
        const { userId, admin } = this.props;
        const { editScore, editDecision } = this.state;
        const empId = admin?.emailId || 'superuser';

        if (editScore < 0 || editScore > 85) {
            alert("Score must be between 0 and 85.");
            return;
        }

        this.setState({ savingScoring: true });
        UpdateLoanApprovalScorngById({
            userId: userId,
            totalScore: Number(editScore),
            scoringDecision: editDecision,
            updatedBy: empId
        }, callback => {
            if (callback === 'success') {
                this.setState({
                    isEditing: false,
                    savingScoring: false,
                    showPopup: true,
                    popupStatus: 'Scoring updated successfully!'
                });
                this.fetchScoringData();
            } else {
                this.setState({
                    savingScoring: false,
                    showPopup: true,
                    popupStatus: 'Failed to update scoring: ' + text
                });
            }
        })


    };

    handleDownload = () => {
        const { crifHtml, userDetails } = this.state;
        if (!crifHtml) return;

        const element = document.createElement("a");
        const file = new Blob([crifHtml], { type: 'text/html' });
        element.href = URL.createObjectURL(file);
        element.download = `CRIF_Report_${userDetails?.userName || this.props.userId}.html`;
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    render() {
        const { handleAnalysis, admin, userId } = this.props;
        const { activeTab, userDetails, crifHtml, concludeData, loadingUser, loadingCrif, loadingScoring, isEditing, editScore, editDecision, savingScoring, showPopup, popupStatus } = this.state;

        // Styles
        const overlayStyle = {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(15, 23, 42, 0.4)',
            backdropFilter: 'blur(10px)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
        };

        const modalStyle = {
            background: '#ffffff',
            width: '90%',
            maxWidth: '1200px',
            height: '85vh',
            borderRadius: '16px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            border: '1px solid #e2e8f0',
            fontFamily: 'Inter, system-ui, sans-serif'
        };

        const headerStyle = {
            padding: '18px 24px',
            borderBottom: '1px solid #f1f5f9',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            background: '#ffffff'
        };

        const closeButtonStyle = {
            background: '#f1f5f9',
            border: 'none',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            color: '#64748b',
            transition: 'all 0.2s ease',
            outline: 'none'
        };

        const tabListStyle = {
            display: 'flex',
            gap: '8px',
            padding: '0 24px',
            borderBottom: '1px solid #f1f5f9',
            background: '#f8fafc'
        };

        const tabStyle = (isActive) => ({
            padding: '14px 24px',
            border: 'none',
            background: 'none',
            fontSize: '14px',
            fontWeight: '700',
            cursor: 'pointer',
            position: 'relative',
            color: isActive ? '#2563eb' : '#64748b',
            transition: 'all 0.2s ease',
            outline: 'none'
        });

        const activeLineStyle = {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '3px',
            background: '#2563eb',
            borderRadius: '3px 3px 0 0'
        };

        const bodyStyle = {
            padding: '24px',
            flex: 1,
            overflowY: 'auto',
            background: '#ffffff'
        };

        const tableStyle = {
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '24px',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            overflow: 'hidden'
        };

        const thStyle = {
            background: '#f8fafc',
            padding: '12px 16px',
            fontSize: '11px',
            fontWeight: '700',
            textTransform: 'uppercase',
            color: '#64748b',
            borderBottom: '1px solid #e2e8f0',
            textAlign: 'center',
            whiteSpace: 'nowrap'
        };

        const tdStyle = {
            padding: '14px 16px',
            fontSize: '13px',
            color: '#334155',
            borderBottom: '1px solid #e2e8f0',
            textAlign: 'center',
            fontWeight: '600',
            whiteSpace: 'nowrap'
        };

        const buttonStyle = (colorType) => ({
            background: colorType === 'success' ? 'linear-gradient(135deg, #059669, #047857)' : 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
            border: 'none',
            color: '#ffffff',
            padding: '10px 20px',
            borderRadius: '8px',
            fontWeight: '700',
            fontSize: '13px',
            boxShadow: colorType === 'success' ? '0 2px 8px rgba(5,150,105,0.2)' : '0 2px 8px rgba(59,130,246,0.2)',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            outline: 'none',
            transition: 'all 0.2s ease'
        });

        const cardStyle = {
            background: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px'
        };

        const cardValueStyle = {
            fontSize: '24px',
            fontWeight: '800',
            color: '#0f172a',
            letterSpacing: '-0.5px'
        };

        const cardLabelStyle = {
            fontSize: '12px',
            fontWeight: '700',
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
        };

        return (
            <div style={overlayStyle}>
                <div style={modalStyle}>
                    {/* Header */}
                    <div style={headerStyle}>
                        <h3 style={{ margin: 0, fontWeight: 800, color: '#0f172a', fontSize: '18px' }}>Application Analysis</h3>
                        <button
                            style={closeButtonStyle}
                            onClick={() => handleAnalysis(false, "")}
                            onMouseEnter={(e) => e.currentTarget.style.background = '#e2e8f0'}
                            onMouseLeave={(e) => e.currentTarget.style.background = '#f1f5f9'}
                        >
                            <i className="fa fa-times" />
                        </button>
                    </div>

                    {/* Tabs */}
                    <div style={tabListStyle}>
                        <button
                            style={tabStyle(activeTab === 'crif')}
                            onClick={() => this.setState({ activeTab: 'crif' })}
                        >
                            CRIF Report
                            {activeTab === 'crif' && <div style={activeLineStyle} />}
                        </button>
                        <button
                            style={tabStyle(activeTab === 'internalScoring')}
                            onClick={() => this.setState({ activeTab: 'internalScoring' })}
                        >
                            Internal Scoring
                            {activeTab === 'internalScoring' && <div style={activeLineStyle} />}
                        </button>
                        <button
                            style={tabStyle(activeTab === 'Signzy')}
                            onClick={() => this.setState({ activeTab: 'Signzy' })}
                        >
                            Signzy
                            {activeTab === 'Signzy' && <div style={activeLineStyle} />}
                        </button>
                        <button
                            style={tabStyle(activeTab === 'uploadBankStatement')}
                            onClick={() => this.setState({ activeTab: 'uploadBankStatement' })}
                        >
                            Upload Bank Statement
                            {activeTab === 'uploadBankStatement' && <div style={activeLineStyle} />}
                        </button>
                    </div>

                    {/* Body */}
                    <div style={bodyStyle}>
                        {loadingUser ? (
                            <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
                                <DotLoader />
                            </div>
                        ) : (
                            <>


                                {/* Tab Content */}
                                {activeTab === 'crif' ? (
                                    <div>
                                        {/* Action Buttons */}
                                        <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
                                            <button
                                                style={buttonStyle('success')}
                                                onClick={() => this.fetchCrifData(true)}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'none'}
                                            >
                                                <i className="fa fa-refresh" /> Regenerate CRIF
                                            </button>
                                            {/* <button
                                                style={buttonStyle('primary')}
                                                onClick={this.handleDownload}
                                                disabled={!crifHtml}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'none'}
                                            >
                                                <i className="fa fa-download" /> Download Report
                                            </button> */}
                                        </div>

                                        {/* Report Viewer */}
                                        {loadingCrif ? (
                                            <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                                                <DotLoader />
                                            </div>
                                        ) : (
                                            <div
                                                style={{
                                                    border: '1px solid #e2e8f0',
                                                    borderRadius: '12px',
                                                    padding: '24px',
                                                    background: '#fafafa',
                                                    overflowX: 'auto',
                                                    maxHeight: '400px',
                                                    overflowY: 'auto'
                                                }}
                                                dangerouslySetInnerHTML={{ __html: crifHtml || "<p style='text-align: center; color: #64748b; padding: 20px;'>No CRIF report found.</p>" }}
                                            />
                                        )}
                                    </div>
                                ) :
                                    activeTab === 'internalScoring' ?
                                        (
                                            <div>
                                                {/* Internal Scoring Details */}
                                                {loadingScoring ? (
                                                    <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>
                                                        <DotLoader />
                                                    </div>
                                                ) : (
                                                    <>
                                                        {/* Edit Action buttons */}
                                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px', gap: '12px' }}>
                                                            {isEditing ? (
                                                                <>
                                                                    <button
                                                                        style={buttonStyle('success')}
                                                                        onClick={this.handleSaveScoring}
                                                                        disabled={savingScoring}
                                                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'none'}
                                                                    >
                                                                        {savingScoring ? 'Saving...' : 'Save'}
                                                                    </button>
                                                                    <button
                                                                        style={{
                                                                            background: '#f1f5f9',
                                                                            border: '1px solid #cbd5e1',
                                                                            borderRadius: '8px',
                                                                            padding: '10px 20px',
                                                                            color: '#0f172a',
                                                                            fontWeight: '700',
                                                                            fontSize: '13px',
                                                                            cursor: 'pointer',
                                                                            outline: 'none',
                                                                            transition: 'all 0.2s ease'
                                                                        }}
                                                                        onClick={() => this.setState({ isEditing: false })}
                                                                        disabled={savingScoring}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <button
                                                                    style={buttonStyle('primary')}
                                                                    onClick={() => this.setState({
                                                                        isEditing: true,
                                                                        editScore: concludeData?.["Loan Approval Score"] !== undefined ? concludeData?.["Loan Approval Score"] : 0,
                                                                        editDecision: concludeData?.['Crif Analysis']?.['FIRST HAND APPROVAL STATUS']?.[0] || 'APPROVED'
                                                                    })}
                                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'none'}
                                                                >
                                                                    <i className="fa fa-pencil" /> Edit Scoring
                                                                </button>
                                                            )}
                                                        </div>

                                                        {/* Scoring Grid Cards */}
                                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '28px' }}>
                                                            <div style={cardStyle}>
                                                                <span style={cardLabelStyle}>Total AI Score</span>
                                                                <span style={cardValueStyle}>{concludeData?.["AI Score"] !== undefined ? concludeData?.["AI Score"] : "-"}</span>
                                                            </div>
                                                            <div style={cardStyle}>
                                                                <span style={cardLabelStyle}>Loan Approval Score</span>
                                                                {isEditing ? (
                                                                    <input
                                                                        type="number"
                                                                        min="0"
                                                                        max="85"
                                                                        value={editScore}
                                                                        onChange={(e) => this.setState({ editScore: Math.min(85, Math.max(0, Number(e.target.value))) })}
                                                                        style={{
                                                                            fontSize: '18px',
                                                                            fontWeight: '800',
                                                                            color: '#0f172a',
                                                                            border: '1px solid #cbd5e1',
                                                                            borderRadius: '8px',
                                                                            padding: '6px 12px',
                                                                            width: '100px',
                                                                            textAlign: 'center',
                                                                            outline: 'none',
                                                                            marginTop: '4px'
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <span style={cardValueStyle}>{concludeData?.["Loan Approval Score"] !== undefined ? concludeData?.["Loan Approval Score"] : "-"}</span>
                                                                )}
                                                            </div>
                                                            <div style={cardStyle}>
                                                                <span style={cardLabelStyle}>Loan Decision</span>
                                                                {isEditing ? (
                                                                    <select
                                                                        value={editDecision}
                                                                        onChange={(e) => this.setState({ editDecision: e.target.value })}
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: '700',
                                                                            color: '#0f172a',
                                                                            border: '1px solid #cbd5e1',
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            outline: 'none',
                                                                            background: '#ffffff',
                                                                            cursor: 'pointer',
                                                                            marginTop: '4px'
                                                                        }}
                                                                    >
                                                                        <option value="APPROVED">APPROVED</option>
                                                                        <option value="REJECTED">REJECTED</option>
                                                                    </select>
                                                                ) : (
                                                                    <span style={{
                                                                        ...cardValueStyle,
                                                                        color: concludeData?.loanDecision === 'APPROVED' ? '#059669' : '#dc2626'
                                                                    }}>
                                                                        {concludeData?.loanDecision || "-"}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Parameter Details Table */}
                                                        <div style={{ overflowX: 'auto', marginBottom: '28px' }}>
                                                            <table style={tableStyle}>
                                                                <thead>
                                                                    <tr>
                                                                        <th style={thStyle}>Scoring Metric</th>
                                                                        <th style={thStyle}>Description</th>
                                                                        <th style={thStyle}>Score</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {(() => {
                                                                        const scoringRows = [];
                                                                        if (concludeData) {
                                                                            Object.keys(concludeData).forEach(key => {
                                                                                if (key !== 'TotalScore' && key !== 'Crif Analysis') {
                                                                                    const innerObj = concludeData[key];
                                                                                    if (innerObj && typeof innerObj === 'object') {
                                                                                        const scoreKey = Object.keys(innerObj)[0];
                                                                                        const reason = innerObj[scoreKey];
                                                                                        scoringRows.push({
                                                                                            metric: key,
                                                                                            score: scoreKey,
                                                                                            description: reason
                                                                                        });
                                                                                    }
                                                                                }
                                                                            });
                                                                        }

                                                                        if (scoringRows.length === 0) {
                                                                            return (
                                                                                <tr>
                                                                                    <td colSpan="3" style={{ ...tdStyle, textAlign: 'center', color: '#64748b' }}>
                                                                                        No scoring metrics available.
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        }

                                                                        return scoringRows.map((row, idx) => (
                                                                            <tr key={idx}>
                                                                                <td style={{ ...tdStyle, fontWeight: '700', textAlign: 'left', paddingLeft: '24px' }}>{row.metric}</td>
                                                                                <td style={{ ...tdStyle, textAlign: 'left', whiteSpace: 'normal' }}>{row.description}</td>
                                                                                <td style={{
                                                                                    ...tdStyle,
                                                                                    fontWeight: '700',
                                                                                    color: Number(row.score) > 0 ? '#059669' : '#64748b'
                                                                                }}>{Number(row.score) > 0 ? `+${row.score}` : row.score}</td>
                                                                            </tr>
                                                                        ));
                                                                    })()}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {/* Crif Analysis - Red & Green Flags */}
                                                        {concludeData?.['Crif Analysis'] && (
                                                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
                                                                {/* Red Flags */}
                                                                {concludeData['Crif Analysis']['Red Flags'] && concludeData['Crif Analysis']['Red Flags'].length > 0 && (
                                                                    <div style={{ border: '1px solid #fecaca', background: '#fef2f2', borderRadius: '12px', padding: '20px' }}>
                                                                        <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', fontWeight: '700', color: '#b91c1c', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                            <i className="fa fa-exclamation-triangle" /> Red Flags
                                                                        </h4>
                                                                        <ul style={{ margin: 0, paddingLeft: '20px', color: '#7f1d1d', fontSize: '13px', lineHeight: '1.6' }}>
                                                                            {concludeData['Crif Analysis']['Red Flags'].map((flag, idx) => (
                                                                                <li key={idx} style={{ marginBottom: '8px' }}>{flag}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                )}

                                                                {/* Green Flags */}
                                                                {concludeData['Crif Analysis']['Green Flags'] && concludeData['Crif Analysis']['Green Flags'].length > 0 && (
                                                                    <div style={{ border: '1px solid #a7f3d0', background: '#ecfdf5', borderRadius: '12px', padding: '20px' }}>
                                                                        <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', fontWeight: '700', color: '#047857', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                            <i className="fa fa-check-circle" /> Green Flags
                                                                        </h4>
                                                                        <ul style={{ margin: 0, paddingLeft: '20px', color: '#064e3b', fontSize: '13px', lineHeight: '1.6' }}>
                                                                            {concludeData['Crif Analysis']['Green Flags'].map((flag, idx) => (
                                                                                <li key={idx} style={{ marginBottom: '8px' }}>{flag}</li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        ) :
                                        activeTab === 'Signzy' ?
                                            <SignzyUpload admin={admin} userId={userId} />
                                            :

                                            <SignzyData admin={admin} userId={userId} />
                                }
                            </>
                        )}
                    </div>
                </div>
                {showPopup && (
                    <SavePopup
                        popupStatus={popupStatus}
                        closePopup={() => this.setState({ showPopup: false })}
                    />
                )}
            </div>
        );
    }
}
